import React from "react";

export default function NJMap({ height = 280 }) {
  return (
    <div className="overflow-hidden rounded-2xl border border-brand-cream shadow-sm bg-white" style={{ height }}>
      <iframe
        title="New Jersey service area map"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1852419.6168267182!2d-76.04614124503816!3d40.06562035685402!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c0fb959e00409f%3A0x2cd27b07f83f6d8d!2sNew%20Jersey!5e1!3m2!1sen!2sus!4v1780844739136!5m2!1sen!2sus"
        className="h-full w-full"
        style={{ border: 0 }}
        loading="lazy"
        allowFullScreen
        referrerPolicy="no-referrer-when-downgrade"
      />
    </div>
  );
}
